export const blockIconsActionFilterAlt = (
	<span className='material-symbols-outlined'>filter_alt</span>
);
